<template>
  <!-- dashboard-content-area-start -->
  <div class="tpd-content-layout">

    <!-- dashboard-tab-area -->
    <div class="dashboader-area mb-25">
      <div class="tp-dashboard-tab">
        <h2 class="tp-dashboard-tab-title">{{ lms_website.__('Order History') }}</h2>
        <div class="tp-dashboard-tab-list">
          <ul>
            <li>
              <a class="pointer-event" @click="payments.active_tab='offline'" :class="(payments.active_tab==='offline')?'active':''">
                {{ lms_website.__('Offline Payments') }} <span>({{ payments.offline?.length }})</span>
              </a>
            </li>
            <li>
              <a class="pointer-event" @click="payments.active_tab='online'" :class="(payments.active_tab==='online')?'active':''">
                {{ lms_website.__('Online Payments') }} <span>({{ payments.online?.length }})</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- dashboard-tab-area-end -->

    <div class="tpd-table mb-25">
      <ul>
        <li class="tpd-table-head">
          <div class="tpd-table-row">
            <div class="tpd-order-id">
              <h4 class="tpd-table-title">{{ lms_website.__('Order ID') }}</h4>
            </div>
            <div class="tpd-order-name" v-if="payments.active_tab==='offline'">
              <h4 class="tpd-table-title">{{ lms_website.__('Program') }}</h4>
            </div>
            <div class="tpd-order-name" v-if="payments.active_tab==='online'">
              <h4 class="tpd-table-title">{{ lms_website.__('Course') }}</h4>
            </div>
            <div class="tpd-order-date">
              <h4 class="tpd-table-title">{{ lms_website.__('Date') }}</h4>
            </div>
            <div class="tpd-order-price">
              <h4 class="tpd-table-title">{{ lms_website.__('Price') }}</h4>
            </div>
            <div class="tpd-order-status">
              <h4 class="tpd-table-title">{{ lms_website.__('Status') }}</h4>
            </div>
            <div class="tpd-order-action"></div>
          </div>
        </li>
        <template v-if="payments.loading">
          <li>
            <div class="placeholder-glow">
              <div class="d-flex gap-3">
                <span class="placeholder d-block rounded" style="width:100%;height:30px;"></span>
                <span class="placeholder d-block rounded" style="width:100%;height:30px;"></span>
                <span class="placeholder d-block rounded" style="width:100%;height:30px;"></span>
                <span class="placeholder d-block rounded" style="width:100%;height:30px;"></span>
                <span class="placeholder d-block rounded" style="width:100%;height:30px;"></span>
              </div>
            </div>
          </li>
        </template>
        <template v-if="!activePayments?.length && !payments.loading">
          <li>
            <div class="pe-3 ps-3">
              <div class="alert alert-warning w-100">
                <i class="far fa-info-circle mr-1"></i> {{ lms_website.__('Not Payments Found') }}
              </div>
            </div>
          </li>
        </template>
        <template v-if="activePayments?.length && !payments.loading">
          <li v-for="payment in paginatedPayments" :key="payment.name">
            <div class="tpd-table-row">
              <div class="tpd-order-id">
                <h4 class="tpd-common-text">#{{ payment.name }}</h4>
              </div>
              <div class="tpd-order-name">
                <h4 class="tpd-common-text">
                  <template v-if="payments.active_tab==='online'">
                    <router-link :to="`/courses/view/${payment.payment_for_document}`">
                      {{ payment.course_title }}
                    </router-link>
                  </template>
                  <template v-if="payments.active_tab==='offline'">
                    {{ payment.custom_program }}
                  </template>
                </h4>
              </div>
              <div class="tpd-order-date">
                <h4 class="tpd-common-text" v-if="payments.active_tab==='online'">{{ moment(payment.creation).format('MMMM DD, YYYY') }}</h4>
                <h4 class="tpd-common-text" v-if="payments.active_tab==='offline'">{{ moment(payment.posting_date).format('MMMM DD, YYYY') }}</h4>
              </div>
              <div class="tpd-order-price">
                <h4 class="tpd-common-text" v-if="payments.active_tab==='online'">{{ format_currency(payment.amount, payment.currency) }}</h4>
                <h4 class="tpd-common-text" v-if="payments.active_tab==='offline'">{{ format_currency(payment.paid_amount_after_tax) }}</h4>
              </div>
              <div class="tpd-order-status">
                <div class="tpd-badge-item" v-if="payments.active_tab==='online'">
                  <span class="tpd-badge warning" v-if="!payment.payment_received">{{ lms_website.__('On Hold') }}</span>
                  <span class="tpd-badge sucess" v-if="payment.payment_received">{{ lms_website.__('Success') }}</span>
                </div>
                <div class="tpd-badge-item" v-if="payments.active_tab==='offline'">
                  <span class="tpd-badge sucess" v-if="payment.docstatus===1">{{ lms_website.__('Success') }}</span>
                </div>
              </div>
              <div class="tpd-order-action">
                <div class="tpd-action-btn">
                  <a :href="`/api/method/frappe.utils.print_format.download_pdf?doctype=${(payments.active_tab==='online')?'LMS Payment':'Payment Entry'}&name=${payment.name}&format=Payment Entry Installment&no_letterhead=1&letterhead=No%20Letterhead&settings=%7B%7D&_lang=${lms_website.user_language}`" :download="payment.name">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13 8.23975V10.7466C13 11.079 12.8595 11.3979 12.6095 11.6329C12.3594 11.868 12.0203 12.0001 11.6667 12.0001H2.33333C1.97971 12.0001 1.64057 11.868 1.39052 11.6329C1.14048 11.3979 1 11.079 1 10.7466V8.23975" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M10.3327 5.38704L6.99935 8.52063L3.66602 5.38704" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M7 1V8.52061" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <span class="tpd-action-tooltip">{{ lms_website.__('Download') }}</span>
                  </a>
                </div>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
    <Pagination
        v-if="!payments.loading"
        :current-page="payments.currentPage"
        :total-items="activePayments?.length"
        :items-per-page="payments.itemsPerPage"
        @page-changed="handlePageChange"
    />
  </div>
</template>

<script>
import {authData, isLoggedIn} from "../../../utils/auth";
import Pagination from "../../../components/Pagination.vue";

export default {
  name: "OrdersHistory",
  components: {Pagination},
  props: {},
  setup() {
    return {
      isLoggedIn,
      lms_website
    }
  },
  data() {
    return {
      authData: authData(),
      moment: moment,
      default_print_format: 'Standard',
      payments: {
        loading: true,
        currentPage: 1,
        itemsPerPage: 5,
        active_tab: 'offline',
        offline: [],
        online: [],
      }
    }
  },
  computed: {
    auth() {
      if (this.authData && this.authData.is_logged_in && this.authData.user) {
        return this.authData;
      }
    },
    activePayments() {
      return this.payments[this.payments.active_tab] || [];
    },
    paginatedPayments() {
      const start = (this.payments.currentPage - 1) * this.payments.itemsPerPage;
      const end = start + this.payments.itemsPerPage;
      return this.activePayments.slice(start, end);
    },
  },
  watch: {},
  methods: {
    async get_user_payments() {
      this.payments.loading = true;
      await frappe.db.get_value(
          "Property Setter",
          {
            "doc_type": "Payment Entry",
            "property": "default_print_format",
          },
          "value",
      ).then(({message}) => {
        console.log('this.default_print_format', message?.value)
        if (message?.value)
          this.default_print_format = message?.value;
      });
      frappe.call({
        type: "GET",
        method: "lms_website.api.user.get_user_payments",
        args: {},
        callback: ({message}) => {
          this.payments.loading = false;
          this.payments.online = message;
        },
      });
      frappe.call({
        type: "GET",
        method: "lms_website.api.user.get_user_orders",
        args: {
          student_id: authData().student_detail.name,
          student_name: authData().student_detail.student_name,
        },
        callback: ({message}) => {
          this.payments.loading = false;
          this.payments.offline = message;
        },
      });
    },
    format_currency(price = 0, currency = '') {
      return format_currency(price, currency);
    },
    handlePageChange(page) {
      this.payments.currentPage = page;
    },
  },
  mounted() {
    setTimeout(() => {
      NProgress.done();
      this.get_user_payments();
      $("[data-background]").each(function () {
        $(this).css("background-image", "url( " + $(this).attr("data-background") + "  )");
      });
    }, 500);
  }
}
</script>

<style scoped>

</style>
